<template>
  <v-row justify="center">
    <v-dialog v-model="showDialog" max-width="1200px" fluid class="mx-0">
      <v-card max-height="700">
        <v-card-title>
          <span class="headline">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid height="100%">
            <v-row v-if="!images || images.length === 0">
              <v-col>
                There are no images
              </v-col>
            </v-row>

            <v-row v-else>
              <v-col cols="2">
                <v-list v-model="selectedImageIdx" height="500px" class="overflow-y-auto">
                  <v-list-item 
                    v-for="(image, i) in images"
                    :key="`image-${i}`"
                    class="pa-0 mb-2"
                  >
                    <v-img width="100%" :src="getImageSrc(image)" cover @click="selectedImageIdx=i" style="cursor:pointer"/>
                  </v-list-item>
              </v-list>
              </v-col>
              <v-col cols="10" class="pb-0">
                <v-img :src="getImageSrc(selectedImage)" contain max-height="500px"/>
                <v-row style="position:relative; top:-1.25em;" class="text-h4 font-weight-bold px-2 outlined">
                  <v-col cols="6" class="text-left">
                    {{ selectedImage.created_by }}
                  </v-col>
                  <v-col cols="6" class="text-right">
                    {{ selectedImage.created_at }}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="normal" class="mr-2" @click="showDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

export default {
  components: {},
  data: () => ({
    showDialog: false,
    title: '',
    images: [],
    selectedImageIdx: 0,
  }),
  computed: {
    selectedImage() {
      if (!this.images || this.images.length === 0 || this.selectedImageIdx >= this.images.length) return '';
      return this.images[this.selectedImageIdx];
    }
  },
  methods: {
    openDialog(images, title = '') {
      this.images = images;
      this.title = title;
      this.showDialog = true;
    },
    getImageSrc(image) {
      return `data:${image.mime_type};base64, ${image.image}`;
    }
  },
};
</script>

<style scoped>
.outlined {
  text-shadow: black 1px 1px 3px, black 1px -1px 3px, black -1px 1px 3px, black -1px -1px 3px;
  color: white
}
</style>
